import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import childrenType from '../proptypes/children';
import {
  mediaBreakpointDownLG,
  mediaBreakpointDownMD,
  mediaOnlyInternetExplorer,
  onlyInternetExplorer,
} from '../constants/style-constants';
import { hunit, vunit } from '../lib/style-helpers';

const columnGap = hunit(4);
const rowGap = vunit(2);

const GridContainer = styled.section`
  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(var(--cards-per-row), 1fr);
    grid-template-rows: auto;
    column-gap: ${columnGap};
    row-gap: ${rowGap};
  }

  ${mediaOnlyInternetExplorer} {
    display: flex;
    flex-wrap: wrap;
    padding: ${rowGap} 0 0 ${columnGap};
    margin: -${rowGap} -${columnGap};
  }
`;

const GridIEOuter = styled.div`
  ${mediaOnlyInternetExplorer} {
    overflow: hidden;
  }
`;

const GridItem = styled.article`
  display: contents;

  ${mediaOnlyInternetExplorer} {
    border: 0 solid transparent;
    border-width: 0 ${columnGap} ${rowGap} 0;
    background-clip: padding-box;
    display: flex;
  }
`;

const cardGridCss = ({ cardsPerRow }) => css`
  & {
    --cards-per-row: ${cardsPerRow};
    ${mediaBreakpointDownLG} {
      /* stylelint-disable-next-line function-name-case */
      --cards-per-row: ${Math.ceil(cardsPerRow / 2)};
    }
    ${mediaBreakpointDownMD} {
      --cards-per-row: 1;
    }
  }`;

const ResponsiveGridContainer = styled(GridContainer)`
  ${cardGridCss}
`;

const ieColumnWidths = ({ cardsPerRow }) => css`
  ${mediaOnlyInternetExplorer} {
    width: ${100 / cardsPerRow}%;
  }
  ${mediaBreakpointDownLG} and ${onlyInternetExplorer} {
    width: ${100 / (cardsPerRow / 2)}%;
  }
  ${mediaBreakpointDownMD} and ${onlyInternetExplorer} {
    width: 100%;
  }
`;

const IEResponsiveGridItem = styled(GridItem)`
  ${ieColumnWidths}
`;

const CardDeck = ({ cardsPerRow, children, ...rest }) => (
  <GridIEOuter>
    <ResponsiveGridContainer cardsPerRow={cardsPerRow} {...rest} data-testid="grid-container">
      {
        children.map((child, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <IEResponsiveGridItem cardsPerRow={cardsPerRow} key={`card-key-${index}`}>{child}</IEResponsiveGridItem>
        ))
      }
    </ResponsiveGridContainer>
  </GridIEOuter>
);

CardDeck.defaultProps = {
  cardsPerRow: 2,
  className: '',
};

CardDeck.propTypes = {
  children: childrenType.isRequired,
  cardsPerRow: PropTypes.oneOf([2, 3, 4]),
  className: PropTypes.string,
};

export default CardDeck;
